const components = [
  {
    icon: 'ri-gift-line',
    title: 'Welcome-программа',
    desc: 'Welcome-пакет: приветственное письмо от CEO, мерч компании, блокнот, ручка. Знакомство с историей, миссией и ценностями компании. Первый день должен запомниться, а не напугать.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Наставничество',
    desc: 'Закреплённый наставник помогает освоить рабочие процессы, отвечает на вопросы, делится опытом и поддерживает в первые недели. Наставник — ключевая фигура в системе адаптации персонала.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Чек-листы',
    desc: 'Готовые чек-листы на первую неделю, первый месяц и испытательный срок. Сотрудник всегда знает, что делать дальше. Руководитель видит прогресс адаптации в реальном времени.',
  },
  {
    icon: 'ri-road-map-line',
    title: 'План обучения',
    desc: 'Расписанный по дням и неделям план ввода в должность. Что изучать, у кого учиться, какие задачи выполнять. Без плана адаптация превращается в хаос.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'База знаний',
    desc: 'Централизованное хранилище регламентов, инструкций, видеоуроков и стандартов компании. Новичок получает доступ в первый день и может вернуться к любому материалу.',
  },
  {
    icon: 'ri-book-3-line',
    title: 'Книга продаж',
    desc: 'Структурированное описание продукта, скриптов, этапов продаж, ответов на возражения и лучших практик. Критически важно для адаптации отдела продаж.',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Обратная связь',
    desc: 'Регулярные встречи с руководителем дают сотруднику понимание, куда двигаться. Фидбэк должен быть конкретным, конструктивным и своевременным — не раз в квартал.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Встречи с руководителем',
    desc: 'График обязательных встреч: ежедневно первую неделю, еженедельно первый месяц, раз в две недели далее. Руководитель не «исчезает», а ведёт сотрудника к результату.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Промежуточная оценка',
    desc: 'Контрольные точки в конце первой недели, первого месяца и середины испытательного срока. Оценка знаний, навыков и прогресса. Корректировка плана при необходимости.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Финальная оценка',
    desc: 'Комплексная оценка в конце испытательного срока: выполнение KPI, усвоение знаний, обратная связь от наставника и руководителя, самооценка сотрудника.',
  },
];

export default function ProgramComponents() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что должно входить в программу адаптации
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Эффективная программа адаптации сотрудников состоит из десяти обязательных элементов. Каждый закрывает свою зону и вместе они создают систему, в которой новичок не теряется.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {components.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}